export default __webpack_public_path__ + "static/media/truco_theme.0a71e2c7.mp3";